<template>
  <div class="box3-container">
    <div class="charts">
      <div id="deviceCount" :style="{width: '100%', height: '100%'}"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "box3",
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total:	0,
          online:	0,
          offline:	0,
          lamp_id:	0,
          cost_electricity:	0,
          total_electricity:	0,
          avg_cost_electricity:	0,
          avg_total_electricity:	0,
          save_electricity:	0,
          avg_save_electricity:	0,
          wifi:	0,
          air:	0,
          g5:	0,
          charging_pile: 0
        };
      },
    },
    camera: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      }
    },
    ip: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      },
    },
    alarm: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      }
    }
  },
  data() {
    return {
      chartOption: {
        grid: {  
          top: '10%',
          left: '5%',
          right: '5%',
          bottom: '2%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false // 隐藏图例
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: true, // 是否显示 X 轴线
              lineStyle: {
                color: 'rgb(19, 47, 83, 1)', // X 轴线的颜色，这里是红色
              }
            },
            axisLabel: {
              show: true,  // 是否显示 X 轴的标签
              color: '#ffffff',  // 标签的颜色，这里是黄色
              fontSize: 12, // 标签的字体大小，单位为像素
              interval: 0 // 强制显示所有标签
            },
            data: this.$t("home.box3.deviceArr"),
          }
        ],
        yAxis: [
          {
            type: 'value',
            interval: 10,
            splitLine: {
              show: true, // 显示辅助线
              lineStyle: {
                color: 'rgba(19, 47, 83, 0.5)', // 设置 Y 轴辅助线颜色
                type: 'dashed', // 可选：设置辅助线类型为点线
                width: 1 // 可选：设置辅助线宽度
              }
            },
            axisLine: {
              show: true, // 是否显示 X 轴线
              lineStyle: {
                color: 'rgb(19, 47, 83, 1)', // X 轴线的颜色，这里是红色
              }
            },
            axisLabel: {
              color: 'rgba(113,140,173, 0.8)', // 设置 Y 轴文字颜色为红色
              fontSize: 12, // 可选：设置字体大小
            }
          }
        ],
        series: [
          {
            name: '设备数量',
            type: 'bar',
            barWidth: 8,
            barGap: 0.5, //柱子之间间距
            itemStyle: { //柱体颜色
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(1, 171, 250, 1)' },
                { offset: 1, color: 'rgba(1, 171, 250, 0)' }
              ]),
              borderWidth: 1, // 边框宽度
              borderRadius: [10, 10, 0, 0] // 上左、上右、下右、下左
            },
            emphasis: {
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(1, 171, 250, 1)' },
                  { offset: 1, color: 'rgba(1, 171, 250, 1)' }
                ])
              }
            },
            label: {
              show: true, // 显示标签
              position: 'top', // 标签位置
              formatter: '{c}', // 使用默认格式，显示数据值
              color: 'rgba(1, 171, 250, 1)' // 设置字体颜色为红色
            },
            data: [0,0,0,0]
          }
        ]
      }
    }
  },
  methods: {
    drawChart () {
      const ipCount = this.ip||0
      const cameraCount = this.camera||0
      const alarmCount = this.alarm||0
      const airCount = this.itemData.air||0
      this.chartOption.series[0].data = [ipCount,cameraCount,alarmCount,airCount]
      var deviceChart = this.$echarts.init(document.getElementById('deviceCount'))
      deviceChart.clear()
      // 绘制图表
      deviceChart.setOption(this.chartOption)
    },
  },
  mounted () {
    this.drawChart()
  }
};
</script>
<style lang='less'>
.box3-container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding:5px 30px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  .charts{
    width: 100%;
    height: 100%;
    position: relative;
  }
}
</style>
